/**
 * Reproduces param-row.ts's DEFAULT_FORMAT (integer-trim / adaptive decimals).
 * createSliderRow's own default is `v.toFixed(1)`, which differs — pass this
 * explicitly wherever a call site relied on param-row's default formatting.
 */
export const paramFormat = (v: number): string => {
  if (Number.isInteger(v)) return String(v);
  if (Math.abs(v) >= 10) return v.toFixed(1);
  return v.toFixed(2);
};
